import {
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuList,
  Popper,
} from "@mui/material";
import Addicon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useState } from "react";

import { useHistory } from "react-router-dom";
import { Button } from "$components";
import useAuth from "$hooks/useAuth";

import { useStyles } from "./BtnGroupCreation.styles";
import { PopinProject } from "./PopinProject";
import { usePopin } from "$components/Popin/usePopin";
import { PopinDockyard } from "./PopinDockyard";

function BtnGroupCreation() {
  const classes = useStyles();
  const history = useHistory();
  const { isAdmin, isClient } = useAuth();
  const { Popin, PopinProps, togglePopin } = usePopin();
  const [wantedForm, setWantedForm] = useState();

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      if (anchorRef.current) {
        anchorRef.current.focus();
      }
    }

    prevOpen.current = open;
  }, [open]);

  const canCreateProjectAndDockyard = isAdmin() || isClient();

  const handleTogglePopin = (type) => {
    setWantedForm(type);
    togglePopin();
  };

  if (!isAdmin()) return null;

  return (
    <div ref={anchorRef}>
      <ButtonGroup
        color="primary"
        aria-label="outlined primary button group"
        className={classes.ButtonGroup}
      >
        <Button
          variant="contained"
          className={canCreateProjectAndDockyard && classes.expandButton}
          onClick={() => history.push("/create-edb")}
        >
          <Addicon />
          Nouvelle EDB
        </Button>
        {canCreateProjectAndDockyard && (
          <Button
            variant="contained"
            className={classes.expandButton}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
            onKeyPress={handleToggle}
            role="button"
            tabIndex={0}
          >
            <ExpandMoreIcon className={classes.ExpandMoreIcon} />
          </Button>
        )}
        {/* If you put one condition "canCreate..." instead of two (like here), the UI is broken. */}
        {canCreateProjectAndDockyard && (
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            placement="bottom-end"
          >
            {({ TransitionProps, placement }) => (
              <ClickAwayListener onClickAway={handleClose}>
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <MenuList
                    autoFocusItem={open}
                    id="menu-list-grow"
                    onKeyDown={handleListKeyDown}
                    className={classes.menuButton}
                  >
                    <ButtonGroup
                      orientation="vertical"
                      size="large"
                      aria-label="vertical contained primary button group"
                    >
                      <Button
                        onClick={() => handleTogglePopin("project")}
                        variant="contained"
                        className={classes.BtnOnPopper}
                      >
                        <Addicon />
                        Nouveau projet
                      </Button>
                      <Button
                        onClick={() => handleTogglePopin("dockyard")}
                        variant="contained"
                        className={classes.BtnOnPopper}
                      >
                        <Addicon />
                        Nouveau chantier
                      </Button>
                    </ButtonGroup>
                  </MenuList>
                </Grow>
              </ClickAwayListener>
            )}
          </Popper>
        )}
      </ButtonGroup>
      <Popin {...PopinProps} minWidth={768}>
        {wantedForm === "project" && <PopinProject togglePopin={togglePopin} />}
        {wantedForm === "dockyard" && (
          <PopinDockyard togglePopin={togglePopin} />
        )}
      </Popin>
    </div>
  );
}

export default BtnGroupCreation;
